export const PLATFORM_INDEX = {
  FIRST_PLATFORM: 0,
  SECOND_PLATFORM: 1,
} as const;

export type PlatformIndex = (typeof PLATFORM_INDEX)[keyof typeof PLATFORM_INDEX];
